<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-default">
                    <div class="box-body">
                        <ul class="nav">
                            <li class="pull-right">
                                <h4>
                    <span class="label label-primary" v-on:click="next">
                      >
                    </span>
                                </h4>
                            </li>
                            <li class="pull-right">
                                <router-link :to="{ name: 'reelsShow', params: { id: reel.id }}" tag="h4">
                                <span class="label label-primary">
                                    <strong>{{ reel.identificativo }}</strong>
                                </span>
                                </router-link>
                            </li>
                            <li class="pull-right">
                                <h4>
                    <span class="label label-primary" v-on:click="prev">
                      &lt;
                    </span>
                                </h4>
                            </li>
                            <li class="pull-right">
                                <router-link :to="{ name: 'fundsShow', params: { id: fund.id }}" tag="h4">
                                <span class="label label-primary">
                                    <strong>{{ fund.denominazione }}</strong>
                                </span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <sequences-form :sequence="sequence" :reel="reel" :disabled="disabled" @activate-mod="activateMod()"
                                @click="updateSequence" @update-sequence-prop="updateSequenceProp"
                                :showLabels="true" :showMap="showMap"></sequences-form>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import sequencesApi from '../../api/sequences'
  import sequencesForm from './SequencesForm.vue'
  import Sequence from '@/models/sequence'

  export default {

    components: {
      sequencesForm
    },

    data () {
      return {
        sequence: false,
        reel: false,
        fund: false,
        disabled: true,
        interval: null
      }
    },

    computed: {
      showMap () {
        return this.$route.params.showMap
      }
    },

    beforeCreate () {
      sequencesApi.show(this.$route.params.id)
        .then((response) => {
          this.sequence = response
          this.fund = response.fund.data
          this.reel = response.reel.data
          this.$store.commit(types.SET_ACTUAL_REEL, response.reel.data)
          this.$store.commit(types.SET_ACTUAL_FUND, response.fund.data)
        })
      this.$emit('addBackgroundColor', 'rgb(234,186,140)')
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Sequenze inserite',
        createButton: {
          display: false,
          text: 'Nuova sequenza',
          to: '/sequence'
        }
      })
      this.interval = setInterval(() => {
        if (!this.disabled) {
          sequencesApi.update(this.$route.params.id, this.sequence)
        }
      }, process.env.AUTOSAVE_TIMEOUT)
    },

    beforeDestroy () {
      clearInterval(this.interval)
    },

    methods: {
      activateMod () {
        this.disabled = !this.disabled
      },
      updateSequence () {
        this.loader = true
        return sequencesApi.update(this.$route.params.id, this.sequence)
          .then((response) => {
            toastr.success('La sequenza è stata salvata correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      },
      prev () {
        sequencesApi.prev(this.sequence.id)
          .then((response) => {
            this.$router.push({name: 'sequencesShow', params: {id: response.data}})
          })
      },
      next () {
        sequencesApi.next(this.sequence.id)
          .then((response) => {
            this.$router.push({name: 'sequencesShow', params: {id: response.data}})
          })
      },
      updateSequenceProp (sequence) {
        this.sequence = new Sequence(false, sequence)
      }
    }
  }
</script>

<style>
    .label-primary {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/sequences/SequencesShow.vue